<template>
  <div class="body">
    <div class="title">
      提现打款
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>交易管理</el-breadcrumb-item>
          <el-breadcrumb-item>提现打款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <button size="medium" @click="piliangtongguo" class="btnss">
          <i class="el-icon-check"></i>
          批量打款</button>
        <button size="medium" @click="piliangtongguo" class="jubaowuxiao">
          <i class="el-icon-close"></i>
          批量拒绝</button>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
            <el-form-item>
              <el-date-picker
                type="date"
                placeholder="打款日期">
              </el-date-picker>
            </el-form-item>
          <el-form-item>
            <el-select  placeholder="排序"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="申请时间倒序 "></el-option>
              <el-option  name="selected" :value="1" label="打款时间倒序 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="提现方式"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="全部 "></el-option>
              <el-option  name="selected" :value="0" label="支付宝 "></el-option>
              <el-option  name="selected" :value="0" label="银行卡 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="打款状态"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="1" label="全部 "></el-option>
              <el-option  name="selected" :value="0" label="已打款 "></el-option>
              <el-option  name="selected" :value="0" label="待打款 "></el-option>
              <el-option  name="selected" :value="0" label="已拒绝 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="举报信息" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tixiandakuan'
}
</script>

<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .right{
      margin-top: 27px;
    }
  }
  .btnss{
    width: 124px;
    height: 43px;
    opacity: 1;
    background: linear-gradient(135deg,#1bb745, #17ab3f);
    border-radius: 5px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    margin-right: 11px;
  }
  .jubaowuxiao{
    width: 124px;
    height: 44px;
    opacity: 1;
    background: linear-gradient(135deg,#e54848, #d54141);
    border-radius: 5px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0px;
    border:none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
